<div class="modal-container" >
    <div
      class="header"
    >Select Medication Type</div>
  </div>
  <div class="modal-container" >
    <div class="result-list-section">
      <ng-container *ngIf="1 > 0; else noData">
          <div class="row no-gutters">
            <div
              class="col d-flex"
              #medDropdown
            >
              <div style="flex: 1">
                <input
                  id="medTypeInput"
                  type="text"
                  class="input"
                  (change)="onTextChange($event)"
                  (keyup)="onTextChange($event)"
                  (blur)="blurDropdown()"
                  [matAutocomplete]="auto"
                  [value]="selectedMed.name"
                  #trigger="matAutocompleteTrigger"
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  [displayWith]="getMedTypeLabel"

                >
                  <mat-option
                    *ngFor="let option of medicationTypeList$ | async"
                    [value]="option"
                    (onSelectionChange)="selectMedicationType(option)"
                    (mousedown)="$event.preventDefault()"
                  >
                    {{ option.name }}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div
                class="icon-container"
                (click)="$event.stopPropagation(); trigger.openPanel(); openSelection();"
              >
                <img
                  src="assets/svg/ico_arrow_down_teal.svg"
                  alt="Arrow Down Icon"
                  width="15"
                />
              </div>
            </div>
          </div>
       <!--   <span
            class="error"
            [style.width.px]="colorDropdown.offsetWidth"
            *ngIf="medTypeInput.touched && color.value === null"
          >Please select a color.</span>-->
      </ng-container>
      <ng-template #noData>
        <div
          text="No Result"
          class="body-1 result-list-text-center"
        ></div>
      </ng-template>
    </div>
</div>

